export class TransactionFilterModel{
    CardNumber: string;
    TxnType:number;
    StartDate =new Date;
    StartDateWise :string;
    StartDateIndividual :string
    EndDate = new Date;
    SkipCount:number;
    VehicleNo:string;
    IsDashBoardCall:boolean;
    TerminalNumber:string;
    MerchantCode: string;
    OutletId:string;
    CustomerCode:number;
    OutletName:string;
    UTRNumber:string;
    BatchId:number;
    MerchantId:string;
    IssuerSettlementStatusId:number;
    TicketId:number;
    IssueType:number;
    IssuerStatus:number;
    OutletAddress:string
    TicketTypeId:number;
    filterModel=new FilterModel();
    constructor(){
        this.CustomerCode=0;
        this.OutletName='';
        this.CardNumber='0';
        this.TxnType=0;
        this.VehicleNo='';
        this.TerminalNumber = '0';
        this.OutletId = '0';
    }
}

export class SearchFilterModel{
    StartDate =new Date;
    EndDate =new Date;
    ProgramId:number;
    TxnSummaryId:number;
    SkipCount:number;
    MerchantId:string;
    filterModel = new FilterModel();
    constructor(){
        this.ProgramId = 1;
        this.TxnSummaryId = 0;
    }
}

export class MerchantHierarchyModel{
    EntityName:string;
    EntityId:number;
    EntityType:number;
    MerchantId:number=0;
    MerchantName:string;
    LocationTypeId:number;
    ParentLocationId:number;

}
// export class ZonalLocation{
//     LocationId:number=0;
//     LocationName:string;
// }
export class FilterModel
    {
         FilterType : number;
         FilterValue : number;
    }


// WEBPACK FOOTER //
// ./src/app/models/customer-transaction-history/Transaction-Filter-model.ts